import { render, staticRenderFns } from "./InputRadio.global.vue?vue&type=template&id=48b2e77b&scoped=true&lang=pug&"
import script from "./InputRadio.global.vue?vue&type=script&lang=ts&"
export * from "./InputRadio.global.vue?vue&type=script&lang=ts&"
import style0 from "./InputRadio.global.vue?vue&type=style&index=0&id=48b2e77b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b2e77b",
  null
  
)

export default component.exports